<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents no_height">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <style-write-component :styleType="'updateStyle'" :styleKey="styleKey"></style-write-component>
                </div>
                <div class="content_btn_wrap text_center">
                    <el-button type="primary" @click="submitForm()">저장</el-button>
                    <el-button type="info" @click="$router.back()">취소</el-button>
                </div>
<!--                <style-fitting-component :styleKey="styleKey"></style-fitting-component>-->
            </div>
        </div>
        <magazine-fitting-edit-modal></magazine-fitting-edit-modal>
        <item-one-select-modal></item-one-select-modal>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import StyleWriteComponent from "@/components/style/StyleWriteComponent";
import magazineFittingEditModal from "@/components/modal/MagazineFittingEditModal.vue";
import styleFittingComponent from "@/components/style/StyleFittingComponent.vue";
import ItemOneSelectModal from "@/components/modal/ItemOneSelectModal.vue";

export default {
    name: "StyleDetail",
    components: {StyleWriteComponent, magazineFittingEditModal,styleFittingComponent, ItemOneSelectModal,},
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            styleKey: this.$route.params.idx,
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('writeStyle');
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>
